import React from 'react';
import { Check, X } from 'lucide-react';

const PasswordMatchValidator = ({ password, confirmPassword, showValidation = false }) => {
  if (!showValidation || !confirmPassword) return null;

  const isMatching = password === confirmPassword;

  return (
    <div className={`mt-2 flex items-center text-sm ${isMatching ? 'text-success' : 'text-error'}`}>
      <div className="mr-2">
        {isMatching ? <Check size={14} /> : <X size={14} />}
      </div>
      <span>
        {isMatching ? 'Passwords match' : 'Passwords do not match'}
      </span>
    </div>
  );
};

export default PasswordMatchValidator;